<template>
  <div id="main-content" class="student-list">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="success" v-if="!isAddFile"  @click="onShowAddItem">+ {{ $t('common.add') }}</el-button>
        </el-form-item>
      </el-form>
      <el-row style="padding-top: 20px">
        <table class="bus-list">
          <tr>
            <th width="5%">#</th>
            <th width="30%">{{ $t('common.title') }}</th>
            <th width="35%">{{ $t('common.file') }}</th>
            <th></th>
          </tr>
          <tr v-for="(attachment, index) in listTerm" :key="attachment.id">
            <td width="5%">{{ index + 1 }}</td>
            <td>
              <span v-show="!attachment.isEditState">{{ attachment.title }}</span>
              <input v-show="attachment.isEditState" style="width: 90%; color: #000; float: none"
                     class="input" v-model="attachment.newTitle" type=""/>
            </td>
            <td>
              <b-form-file
                  v-if="attachment.isEditState"
                  @change="onUploadFile($event, true, attachment)"
                  accept=".pdf"
                  :placeholder="$t('common.choose_file')"
                  :drop-placeholder="$t('common.drop_file')"
              >
                <template slot="file-name" slot-scope="{ names }">
                  {{ formatName(names[0], 12) }}
                </template>
              </b-form-file>
              <PreviewFile v-if="!attachment.isEditState" :file-url="attachment.file_url"></PreviewFile>
            </td>
            <td>
              <b-button v-if="!attachment.isEditState"
                        variant="primary" @click="onShowEditItem(attachment,true)"
                        style="margin-right: 10px">{{ $t('common.edit') }}
              </b-button>
              <b-button v-if="attachment.isEditState"
                        variant="primary" @click="onEditItem(attachment)"
                        style="margin-right: 10px">{{ $t('common.save') }}
              </b-button>
              <b-button  variant="warning" @click="onShowEditItem(attachment,false)"
                         style="margin-right: 10px" v-if="attachment.isEditState"
                         >{{ $t('common.cancel') }}
              </b-button>
              <b-button  variant="danger"
                        style="margin-right: 10px" @click="onDeleteItem(attachment)"
                        >{{ $t('common.delete') }}
              </b-button>
            </td>
          </tr>
          <tr v-if="isAddFile">
            <td width="5%">{{ listTerm.length + 1 }}</td>
            <td>
              <input  style="width: 90%; color: #000; float: none" class="input" v-model="addItem.title" type=""/>
            </td>
            <td >
              <b-form-file style="width: 90%"
                  @change="onUploadFile($event, false)"
                  accept=".pdf"
                  :placeholder="$t('common.choose_file')"
                  :drop-placeholder="$t('common.drop_file')"
              >
                <template slot="file-name" slot-scope="{ names }">
                  {{ formatName(names[0], 12) }}
                </template>
              </b-form-file>
            </td>
            <td>
              <b-button
                        variant="success" @click="onCreateItem"
                        style="margin-right: 10px">{{ $t('common.save') }}
              </b-button>
              <b-button
                        variant="primary" @click="onCancelCreate"
                        style="margin-right: 10px">{{ $t('common.cancel') }}
              </b-button>
            </td>
          </tr>
        </table>
      </el-row>
    </el-col>
  </div>
</template>
<script>
import PageTitle from "../../components/PageTitle";
import PreviewFile from "../../components/PreviewFile";
export default {
  components : {
    PageTitle,
    PreviewFile
  },
  data(){
    return {
      backLink: '',
      title:"termOfUser.titlePage",
      listTerm : [],
      itemEdit: null,
      isAddFile: false,
      termEdit : {
        title:'',
        id: '',
        file_url: ''
      },
      addItem : {
        title:'',
        id: '',
        file_url: ''
      },
      infoError: {
        title:'',
        file_url: ''
      }
    }
  },
  created() {
    this.onGetList()
  },
  methods:{
    onShowEditItem(attachment,isEdit){
      let id = attachment.id
      attachment.id = null
      attachment.id = id
      attachment.isEditState = isEdit
      attachment.newTitle = attachment.title
      attachment.newFileUrl = null
    },
    onEditItem(attachment){
      let data = Object.assign({}, attachment)
      data.title = data.newTitle
      data.file_url= data.newFileUrl ? data.newFileUrl :data.file_url
      let check = this.onValidate(data)
      if(check){
        let successCallback =(response) =>{
          if(response.status ===200){
            attachment.title = data.newTitle
            attachment.file_url= data.newFileUrl ? data.newFileUrl :data.file_url
            this.onShowEditItem(attachment,false)
            attachment.newTitle = null
          }
        }
        let errorCallback = () =>{}

        let payload ={
          successCallback,
          errorCallback,
          data: data
        }
        this.$store.dispatch('termUser/updateTerm', payload)
      }else{
        this.$store.commit('openNotification', {
          type: 'error',
          message: this.infoError.title || this.infoError.file_url
        })
      }

    },
    onCancelEdit(){
      this.itemEdit = null
      this.termEdit = {
        title:'',
        id: '',
        file_url: ''
      }
    },
    onDeleteItem(item){
      let successCallback =(response) =>{
        if(response.status ===200){
          this.onGetList()
          this.isAddFile = false
          this.itemEdit = null
        }
      }
      let errorCallback = () =>{}
      let payload ={
        successCallback,
        errorCallback,
        term_id: item.id
      }
      this.$store.commit('openConfirm', {
        title: this.$t('common.delete'),
        message: this.$t('msg.deleteConfirm', {field: this.$t('nameField.termOfUser')}),
        callback: () => {
          this.$store.dispatch('termUser/deleteTerm', payload)
        }
      })

    },
    onShowAddItem(){
      this.isAddFile = true
    },
    onCreateItem(){
      let data = Object.assign({}, this.addItem)
      let check = this.onValidate(data)
      if(check){
        let successCallback =(response) =>{
          if(response.status ===200){
            this.onGetList()
            this.onCancelCreate()
          }
        }
        let errorCallback = () =>{}
        let payload ={
          successCallback,
          errorCallback,
          data: data
        }
        this.$store.dispatch('termUser/createTerm', payload)
      }else{
        this.$store.commit('openNotification', {
          type: 'error',
          message: this.infoError.title || this.infoError.file_url
        })
      }

    },
    onUploadFile(event, isEdit= false, attachment =null){
      let  file = event.target.files[0]
      let successCallback = async (response) => {
        if(response.status ===200){
          let url = await response.data.data.file_url
          if(url){
            if(isEdit){
              attachment.newFileUrl = url
            }else{
              this.addItem.file_url = url
            }
          }
        }
      }
      let errorCallback = () => {}
      let formData = new FormData()
      formData.append('file', file)
      let payload = {
        data: formData,
        successCallback,
        errorCallback
      }
      let size = file.size / 1024 / 1024 > 25
      if (size) {
        this.$notify({
          title: this.$t('msg.titleError'),
          message: this.$t('msg.imageSize'),
          type: 'error'
        })
        return false
      }else{
        this.$store.dispatch('CategoriesFile/uploadFile', payload)
      }
    },
    onCancelCreate(){
      this.isAddFile = false
      this.addItem = {
        title:'',
        id: '',
        file_url: ''
      }
    },
    formatName (name, max) {
      if (name.length <= max) {
        return name
      }

      return name.substr(0, max) + '...'
    },
    onGetList(){
      let successCallback =(response) =>{
        if(response.status ===200){
          let data = response.data.data.data_list
          this.listTerm = data
        }
      }
      let errorCallback = () =>{}
      let payload ={
        successCallback,
        errorCallback
      }
      this.$store.dispatch('termUser/getListTerm', payload)
    },
    onResetError(){
      this.infoError = {
        title:'',
        file_url: ''
      }
    },
    onValidate(item = {}){
      this.onResetError()
      let check = true
      if(item.title ==="" || this.title === null || (this.title && this.title.trim()==="")){
        check = false
        this.infoError.title =this.$t('common.title_is_required')
      }else{
        this.infoError.title = ""
      }
      if(item.title && item.title.length >255){
        check = false
        this.infoError.title =this.$t('common.errorMaxLength', {field: 255})
      }
      if(item.file_url ==="" || this.file_url === null){
        check = false
        this.infoError.file_url =this.$t('common.file_is_required')
      }else{
        this.infoError.file_url = ""
      }
      return check
    }
  }
}
</script>
